import { getCheckout, State as CheckoutState } from "./checkout";
import { Discount } from "../../../../../models";

export type State = CheckoutState;
export const getWebdealsInCart: (state: State) => Discount[] = (state) => getCheckout(state).webdeals || [];
